export default {
  configure: '配置',
  chat: '聊天',
  transferToAgent: '转移到代理',
  clickToHelpPerson: '此人需要帮助，单击以帮助他们',
  openConversation: '打开对话',
  conversations: '对话',
  noPendingConversations: '没有挂起的对话',
  lastMessage: '最后一条消息',
  channel: '通道',
  yourConversations: '您的对话',
  closedConversations: '已关闭的对话',
  allConversations: '所有对话',
  finishConversation: '结束对话',
  closeChat: '近距离聊天',
  loadingMessages: '正在加载消息',
  noMessagesFound: '没有任何消息',
  conversationAlreadyTaken: '已进行对话',
  toWrite: '写',
  toHelp: '帮助',
  attendConversation: '参加对话',
  quickResponses: '快速响应',
  writeMessage: '写入消息',
  conversationFinishedByAdvisor: '由顾问完成的对话',
  finishedConversation: '已完成对话',
  conversationTakenByAdvisor: '顾问的谈话',
  updatedConversation: '更新的对话',
  configureChat: '配置聊天',
  loadingConversations: '加载对话',
  waitingForAdvisor: '等待顾问',
  finished: '完成',
  takenByMe: '被我带走',
  takenByAdvisor: '由 [顾问] 拍摄',
  withAdvisor: '与顾问',
  registered: '此人尚未写信',
  canIHelpYouWithSomething: '我能帮你做点什么吗？',
  attachInWebSite: '在网站中附加',
  authenticationType: '身份验证类型',
  noAuthentication: '无身份验证',
  externalAuthentication: '外部身份验证',
  form: '形式',
  city: '城市',
  appearance: '外观',
  light: '光',
  dark: '黑暗',
  mainColor: '主色',
  pickAMainColor: '选择主颜色',
  reestablishColor: '重建颜色',
  backgroundColor: '背景颜色',
  pickABackgroundColor: '选择背景颜色',
  customLogo: '自定义徽标',
  customTitle: '自定义标题',
  customBubbleMessage: '自定义气泡消息',
  showEmojis: '显示表情符号',
  customQuestions: '自定义问题',
  insertChatQuestions: '输入要在聊天中显示的问题',
  permanentMessages: '永久消息',
  insertFirstChatMessages: '输入要作为第一个聊天消息显示的邮件',
  reasonsOfFinishedConversation: '完成对话的原因',
  possibleReasonsAdvisorEndConversation: '输入顾问可能结束对话的主要原因',
  insertQuickResponsesForAdvisors: '输入顾问可用的快速响应',
  inactivityMessage: '语用性消息',
  enableInactivityMessage: '启用非活动性消息',
  insertInactivityMessage: '输入非活动状态消息',
  timeForTriggeringInactivityMessage: '触发不活动消息的时间（以秒为单位）',
  attentionSchedule: '关注时间表',
  outOfServiceMessage: '服务外消息',
  customFormMessage: '自定义表单消息',
  nonWorkingDay: '非工作日',
  allDay: '一整天',
  noOpening: '无开口',
  noClosing: '无关闭',
  advisors: '顾问',
  assignConversationsAutomaticallyToConnectedAdvisors: '将自动将对话分配给已连接的顾问',
  pickAdvisors: '挑选顾问',
  monday: '星期一',
  tuesday: '星期二',
  wednesday: '星期三',
  thursday: '星期四',
  friday: '星期五',
  saturday: '星期六',
  sunday: '星期天',
  configurationSavedSuccessfully: '已成功保存的设置',
  insertChatInYourWebSite: '在 yor 网站中插入聊天',
  instructionsForInsertingChat: '为了在您的网站中添加聊天内容，您必须在网站页脚中添加下一个脚本',
  copiedScript: '复制的脚本',
  errorCopyingScript: '复制脚本错误',
  noMessage: '无消息',
  toTransfer: '转移',
  agentSuccessfullyTransferred: '代理成功转移',
  youAreDeclaringNoWorkingDay: '你宣布这一天为非工作日',
  opening: '开放',
  closing: '关闭',
  establishAgentsForSelfAllocationOfConversations: '建立自分配对话的代理',
  assignConversations: '分配对话',
  ready: '准备',
  advisorUpdated: '更新顾问',
  errorPrecessingRequest: '处理请求时出错',
  periodStatistics: '期间统计',
  noStatsFoundForThisDateRange: '未找到此日期范围的统计信息',
  forEachDayHowMuchWasTheAverageTimePerConversation: '每天，每次对话的平均时间是多少？',
  forEachAdvisorHowMuchWasTheAverageTimePerConversation: '对于每位顾问，每次谈话的平均时间是多少？',
  statsPerDay: '每天的统计数据',
  noStatsFoundForThisDay: '当天未找到统计数据',
  usersCreated: '用户创建',
  attendedConversations: '参加对话',
  noAttendedConversations: '未回答的对话',
  attendedAndUnansweredConversations: '参加和无人参与的对话',
  attended: '参加',
  averageTimeBeforeTheAdvisorTookControl: '顾问控制前的平均时间',
  averageTimeSinceTheAdvisorTookControl: '顾问控制以来的平均时间',
  howManyWereAttended: '有多少人参加？',
  conversationsNumber: '对话次数',
  howManyConversationsDidEachAdvisorAttended: '每位顾问参加了多少次对话？',
  numberConversationsAttended: '参加的对话次数',
  howManyUsersWereCreated: '创建了多少用户？',
  users: '用户',
  howLongWasTheAverageTimePerConversation: '每次对话的平均时间有多长？',
  minutes: '分钟',
  whatWereTheTopicsOfTheConversations: '对话的主题是什么？',
  numberOfRepetitions: '重复次数',
  howManyConversationsWereAttendedForEachHour: '每小时参加多少次对话？',
  howManyConversationsDidEachAdvisorHavePerHour: '每个顾问每小时有多少次对话？',
  howManyUsersWereCreatedPerHour: '每小时创建多少用户？',
  advisor: '顾问',
  tellUsWhoYouAre: '告诉我们你是谁',
  selectTheInformationYouWantToAskPeople: '选择要询问人员的信息',
  startConversation: '开始对话',
  emptyMessage: '空消息',
  blockMessageComposer: '块状信息合成器',
  timeZone: '时区',
  addSchedule: '添加时间表',
  checkTheServiceHours: '查看服务时间',
  newKeybeConversation: '新密钥对话',
  details: '细节',
  enterName: '输入名称',
  enterEmail: '输入电子邮件',
  enterPhone: '输入电话',
  enterCountry: '输入国家/地区',
  country: '国家',
  enter: '进入',
  enterValue: '输入值',
  selectPerson: '选择人员',
  anonymousPerson: '此人是匿名的',
  personDetails: '人员详情',
  newApplication: '新应用程序',
  channels: '频道',
  authentication: '认证方式',
  finalization: '结尾',
  customizeYourConversation: '自定义您的对话',
  schedules: '时间表',
  assignment: '分配',
  correctlyEmailConnection: '您的电子邮件已正确连接',
  correctlyEmailDisconnection: '您的电子邮件已成功断开连接',
  administratorsOnly: '仅管理员',
  setTheEndTimeForConversations: '设定对话的结束时间',
  automaticallyEndUnansweredConversations: '自动结束已停止应答的对话',
  definesTheTimeUserStopsResponding: '定义用户停止响应后结束对话的时间',
  finishAfter: '完成后',
  enterTheReasonForAutomaticCompletion: '输入自动完成的原因',
  position: '位置',
  defaultLanguage: '预设语言',
  tagsAsAMethodOfAutoAssignment: '标签作为自动分配方法',
  enterTags: '输入标签',
  updateTags: '更新标签',
  communicationChannels: '沟通渠道',
  youMustPreviouslyGrantKeybeGooglePermission: '您必须事先授予Keybe权限才能访问您的Google帐户',
  connectWithGoogle: '与Google联系',
  youHaveCurrentlyAuthorizedKeybe: '您当前已授权Keybe访问您的帐户',
  andYouHaveCorrectlyConfiguredGmail: '并且您已经正确配置了Gmail',
  disconnectFromGmail: '与Gmail断开连接',
  connectToGmail: '连接到gmail',
  notificationPermissions: '您拒绝了显示通知的权限。检查网址栏中的站点信息，并在收到消息时允许通知继续接收警报',
  dontShowMessage: '不再显示此消息'
}
